export default {
  SORT_ASC: 'ASC',
  SORT_DESC: 'DESC',
};
